export enum STOCK_OPERATIONS {
  ADDED = 'ADDED',
  DISCOUNTED = 'DISCOUNTED',
}
